var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, action } from "mobx";
var ComponentRemove = /** @class */ (function () {
    function ComponentRemove() {
        this.active = false;
    }
    ComponentRemove.prototype.init = function (opts) {
        this.component = opts.component;
        this._saveHandler = opts.saveHandler;
        this.active = true;
    };
    ComponentRemove.prototype._close = function () {
        //this.component = undefined;
        this.active = false;
    };
    ComponentRemove.prototype.save = function () {
        if (this._saveHandler) {
            this._saveHandler(this.component);
        }
        else {
            this.component.removeFromParent();
        }
        this._close();
    };
    ComponentRemove.prototype.cancel = function () {
        this._close();
    };
    __decorate([
        observable
    ], ComponentRemove.prototype, "active", void 0);
    __decorate([
        observable
    ], ComponentRemove.prototype, "component", void 0);
    __decorate([
        action
    ], ComponentRemove.prototype, "init", null);
    __decorate([
        action
    ], ComponentRemove.prototype, "_close", null);
    __decorate([
        action
    ], ComponentRemove.prototype, "save", null);
    __decorate([
        action
    ], ComponentRemove.prototype, "cancel", null);
    return ComponentRemove;
}());
export { ComponentRemove };
